import { useSelector } from "react-redux";
import { useEffect, useRef, useState } from 'react';

// Login-app id -> module whose permission gates that app. Apps not listed
// here (e.g. the general "hrms" app) are open to every signed-in user.
const APP_MODULE = {
  hrdashboard: "HR",
  crm: "CRM",
};

export const hasAppAccess = (user, appId) => {
  const module = APP_MODULE[appId];
  return !module || hasModuleAccess(user, module);
};

export const hasModuleAccess = (user, module) => {


  if (!user) return false;

  switch (module) {
    case "CRM":
      return user.crmAccess === true;

    case "HR":
      return [
        "SUPER_ADMIN",
        "ADMIN",
        "HR",
      ].includes(user.role);

    default:
      return false;
  }
};
